module.exports = __webpack_public_path__ + "202408221624/img/animation_aichou.5bb5df8f.png";